<template>
  <div id="admin-header" class="bg-header">
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center">
        <div class="pl-1 pr-1">
          <hit-button
            v-if="!responsiveBreakpointMd"
            prefix-icon="menu"
            color="header"
            hide-border
            :remove-outline="true"
            icon-size="lg"
            aria-label="Open menu"
            @click.stop="$emit('toggleSidebarVisibility')"
          />
        </div>
        <div class="px-2 flex flex-row items-center">
          <div
            class="icon-wrapper flex items-center justify-center logo-style"
            style="width: 40px"
          >
            <img src="/assets/ficos_logo_white.svg" alt="Ficos" />
          </div>
          <!-- <div>
            <span
              class="text-header text-base leading-none"
              style="margin: 0px 6px"
              >Ficos</span
            >
          </div> -->
        </div>
      </div>
      <div class="flex items-center gap-2 px-2">
        <!-- User profile dropdown -->
        <hit-dropdown
          :label="userProfileName"
          button-color="header"
          :hide-label="false"
          :hide-dropdown-icon="false"
          :hide-border="true"
          :items="dropdownItems"
        >
          <template #prefix>
            <hit-avatar />
          </template>
          <template #afterItems>
            <div class="flex justify-center items-center pt-1">
              <hit-icon icon="info" size="xs" />
              <p style="font-size: 0.6rem">
                Hit-Online Admin {{ versionToDisplay }}
              </p>
            </div>
          </template>
        </hit-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue';
import {
  HitDropdown,
  HitAvatar,
  DropdownItem,
  HitIcon,
  HitButton,
  HitBreakpointsMixin,
} from '@hit/components';
import {useUserProfileStore, useCompanyProfileStore} from '@hit/base';
import {globals} from '@admin/globals.js';
import {currentVersion} from '@/../../app/src/version.js';

export default defineComponent({
  name: 'AdminHeader',
  components: {
    HitDropdown,
    HitAvatar,
    HitIcon,
    HitButton,
  },
  mixins: [HitBreakpointsMixin],
  emits: ['toggleSidebarVisibility'],
  setup() {
    const user = useUserProfileStore();
    const company = useCompanyProfileStore();
    return {user, company};
  },
  data() {
    return {};
  },
  computed: {
    userProfileName() {
      const token = globals.$keycloak?.tokenParsed || {};

      const fullNameFromToken =
        token.given_name || token.family_name
          ? `${token.given_name || ''} ${token.family_name || ''}`.trim()
          : '';

      const username =
        fullNameFromToken ||
        token.name ||
        token.preferred_username ||
        token.email ||
        (this.user && this.user.username) ||
        '';

      const companyName =
        token.company_name ||
        token.company_id ||
        (this.company && this.company.name) ||
        '';

      if (username && companyName) {
        return `${username} (${companyName})`;
      }
      if (username) {
        return username;
      }
      if (companyName) {
        return companyName;
      }
      return 'Utilisateur';
    },
    versionToDisplay() {
      const regex = /webui-v(\d+\.\d+\.\d+(\.\w+)?)/;
      const match = currentVersion.match(regex);
      if (match && match[1]) {
        return 'v' + match[1];
      } else if (currentVersion === 'VERSION') {
        return '- localhost';
      } else {
        return currentVersion;
      }
    },
    dropdownItems() {
      return [
        new DropdownItem({
          icon: 'disconnect',
          label: this.$t('hit-admin.common.logout'),
          separatorAfter: true,
          color: 'panel-light',
          clickEventHandler: this.logout,
        }),
      ];
    },
  },
  methods: {
    async logout() {
      try {
        const adminApiUrl =
          process.env.VUE_APP_ADMIN_API_URL || 'http://localhost:31109';

        const baseUrl = adminApiUrl.endsWith('/')
          ? adminApiUrl.slice(0, -1)
          : adminApiUrl;
        const logoutLogUrl = `${baseUrl}/log/log-logout`;

        const userId = globals.$keycloak.tokenParsed.sub;
        const companyId = globals.$keycloak.tokenParsed.company_id;
        const sessionId = globals.$keycloak.tokenParsed.sid;

        const userAgent = navigator.userAgent;

        const params = new URLSearchParams({
          user_id: userId,
          company_id: companyId,
          user_agent: userAgent,
          session_id: sessionId,
        });

        const response = await fetch(`${logoutLogUrl}?${params}`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${globals.$keycloak.token}`,
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          console.info('Logout successfully logged to Admin API');
        } else {
          console.warn('Failed to log logout to Admin API:', response.status);
        }
      } catch (error) {
        console.error('Error logging logout to Admin API:', error);
      }

      sessionStorage.removeItem('has_logged_login');

      globals.$keycloak.logout();
    },
  },
});
</script>

<style lang="scss">
#admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3em 0.1em;
  height: 3.4em;
  overflow: hidden;
}

.icon-wrapper {
  width: 30px;
  height: 30px;
  margin-left: 4px;
}

.logo-style {
  width: 3em;
  height: 3em;
}

// Prevent logo image from exceeding header height (mobile)
.logo-style img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  height: auto;
  width: auto;
}
</style>
